import React, { useState, useRef, useEffect } from "react";

export function UserSelectDropdown({ users, value, onChange, buttonClassName, dropdownAlign = "left" }) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  const selectedUser = users.find((u) => u.uid === value);
  const displayValue = selectedUser
    ? (selectedUser.status === "Inactive" ? `${selectedUser.name} (Inactive)` : selectedUser.name)
    : "Select Assignee...";

  // Only show active users in assignee list; include current assignee if already assigned
  const selectableUsers = users.filter((u) =>
    (u.status || "Active") === "Active" || u.uid === value
  );

  // Filter users based on search
  const filteredUsers = selectableUsers.filter((u) =>
    u.name.toLowerCase().includes(search.toLowerCase())
  );

  // Close dropdown on click outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        type="button"
        className={buttonClassName || `border border-gray-200 rounded px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-gray-300 min-w-[120px] text-left flex justify-between items-center bg-white ${!value ? "text-gray-400 italic" : "text-gray-600"}`}
        onClick={() => {
          setIsOpen(!isOpen);
          setSearch("");
        }}
      >
        <span className="truncate">{displayValue}</span>
        <span className="ml-2 text-[10px] text-gray-400">▼</span>
      </button>

      {isOpen && (
        <div className={`absolute z-50 mt-1 ${dropdownAlign === "right" ? "right-0" : "left-0"} w-48 bg-white border border-gray-200 rounded shadow-lg`}>
          <div className="p-1.5 border-b border-gray-100">
            <input
              type="text"
              autoFocus
              placeholder="Search user..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full border border-gray-200 rounded px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-blue-300"
            />
          </div>
          <ul className="max-h-48 overflow-y-auto py-1">
            {filteredUsers.length > 0 ? (
              filteredUsers.map((u) => (
                <li
                  key={u.uid}
                  className={`px-3 py-1.5 text-xs cursor-pointer hover:bg-gray-100 truncate flex items-center justify-between ${
                    value === u.uid ? "bg-blue-50 font-medium text-blue-600" : "text-gray-700"
                  }`}
                  onClick={() => {
                    onChange(u.uid);
                    setIsOpen(false);
                  }}
                >
                  <span className="truncate">{u.name}</span>
                  {u.status === "Inactive" && (
                    <span className="ml-1 text-[10px] text-gray-400 font-normal italic">(Inactive)</span>
                  )}
                </li>
              ))
            ) : (
              <li className="px-3 py-1.5 text-xs text-gray-400 text-center italic">
                No users found
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
}
